/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * API specification for Podcasts Abbreviated
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ApproveSocialPost200,
  BackfillSubscription200,
  BackfillSubscriptionBody,
  CreateJobBodyOne,
  CreateJobBodyTwo,
  CreateRssJobBody,
  CreateSubscription201,
  CreateSubscriptionBody,
  CurrentUser,
  ErrorResponse,
  GenerateJobImageBody,
  GetJobStatsParams,
  GetQuoteVideoUrl200,
  GetRssEpisodesParams,
  GetSocialPostByJob200,
  HealthStatus,
  Job,
  JobQueuePosition,
  JobStats,
  JobTimingStats,
  JobUploadUrlResponse,
  ListJobsParams,
  ListQuoteVideos200,
  ListSocialAccounts200,
  ListSocialPosts200,
  ListSocialPostsParams,
  ListSubscriptionEpisodes200,
  ListSubscriptionEpisodesParams,
  ListSubscriptions200,
  QuoteVideo,
  RegenerateJobBody,
  RenderJobVideo202,
  RenderJobVideoBody,
  RenderQuoteVideoBody,
  ReopenSocialPost200,
  RequestJobUploadUrlBody,
  RetryJobBody,
  RetrySocialPost200,
  RssFeedResult,
  UpdateQuoteVideoPreference200,
  UpdateQuoteVideoPreferenceBody,
  UpdateSocialPost200,
  UpdateSocialPostBody,
  UpdateSubscription200,
  UpdateSubscriptionBody,
  UpdateUserPreferences200,
  UpdateUserPreferencesBody,
  UpdateWordCutsBody,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the current authenticated user's profile and usage
 */
export const getGetCurrentUserUrl = () => {
  return `/api/auth/me`;
};

export const getCurrentUser = async (
  options?: RequestInit,
): Promise<CurrentUser> => {
  return customFetch<CurrentUser>(getGetCurrentUserUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCurrentUserQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({
    signal,
  }) => getCurrentUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUser>>
>;
export type GetCurrentUserQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the current authenticated user's profile and usage
 */

export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Sets the user's preferred vibe profile, video format, and/or autoQuoteVideos flag. Accepts any subset of the three fields. These are used when a new RSS episode completes processing to automatically generate cinematic beat images and per-quote videos in the background. Per-subscription overrides take precedence.

 * @summary Update the current user's global video and quote-video preferences
 */
export const getUpdateUserPreferencesUrl = () => {
  return `/api/auth/preferences`;
};

export const updateUserPreferences = async (
  updateUserPreferencesBody: UpdateUserPreferencesBody,
  options?: RequestInit,
): Promise<UpdateUserPreferences200> => {
  return customFetch<UpdateUserPreferences200>(getUpdateUserPreferencesUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateUserPreferencesBody),
  });
};

export const getUpdateUserPreferencesMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserPreferences>>,
    TError,
    { data: BodyType<UpdateUserPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserPreferences>>,
  TError,
  { data: BodyType<UpdateUserPreferencesBody> },
  TContext
> => {
  const mutationKey = ["updateUserPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserPreferences>>,
    { data: BodyType<UpdateUserPreferencesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateUserPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserPreferences>>
>;
export type UpdateUserPreferencesMutationBody =
  BodyType<UpdateUserPreferencesBody>;
export type UpdateUserPreferencesMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update the current user's global video and quote-video preferences
 */
export const useUpdateUserPreferences = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserPreferences>>,
    TError,
    { data: BodyType<UpdateUserPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserPreferences>>,
  TError,
  { data: BodyType<UpdateUserPreferencesBody> },
  TContext
> => {
  return useMutation(getUpdateUserPreferencesMutationOptions(options));
};

/**
 * @summary List all jobs
 */
export const getListJobsUrl = (params?: ListJobsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/jobs?${stringifiedParams}`
    : `/api/jobs`;
};

export const listJobs = async (
  params?: ListJobsParams,
  options?: RequestInit,
): Promise<Job[]> => {
  return customFetch<Job[]>(getListJobsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListJobsQueryKey = (params?: ListJobsParams) => {
  return [`/api/jobs`, ...(params ? [params] : [])] as const;
};

export const getListJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof listJobs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListJobsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listJobs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListJobsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobs>>> = ({
    signal,
  }) => listJobs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listJobs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListJobsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listJobs>>
>;
export type ListJobsQueryError = ErrorType<unknown>;

/**
 * @summary List all jobs
 */

export function useListJobs<
  TData = Awaited<ReturnType<typeof listJobs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListJobsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listJobs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListJobsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Accepts two request body shapes: (1) multipart/form-data with the raw audio file — suitable for small files only, subject to Replit proxy size limits (~32 MB). (2) application/json with { objectKey, mode, originalName, targetPercent } — used after uploading a large file directly to GCS via POST /jobs/upload-url. The server downloads the object from GCS, verifies ownership, and processes normally.

 * @summary Create a new abbreviation job
 */
export const getCreateJobUrl = () => {
  return `/api/jobs`;
};

export const createJob = async (
  createJobBody: CreateJobBodyOne | CreateJobBodyTwo,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getCreateJobUrl(), {
    ...options,
    method: "POST",
    body: JSON.stringify(createJobBody),
  });
};

export const getCreateJobMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createJob>>,
    TError,
    { data: BodyType<CreateJobBodyOne | CreateJobBodyTwo> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createJob>>,
  TError,
  { data: BodyType<CreateJobBodyOne | CreateJobBodyTwo> },
  TContext
> => {
  const mutationKey = ["createJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createJob>>,
    { data: BodyType<CreateJobBodyOne | CreateJobBodyTwo> }
  > = (props) => {
    const { data } = props ?? {};

    return createJob(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof createJob>>
>;
export type CreateJobMutationBody = BodyType<
  CreateJobBodyOne | CreateJobBodyTwo
>;
export type CreateJobMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a new abbreviation job
 */
export const useCreateJob = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createJob>>,
    TError,
    { data: BodyType<CreateJobBodyOne | CreateJobBodyTwo> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createJob>>,
  TError,
  { data: BodyType<CreateJobBodyOne | CreateJobBodyTwo> },
  TContext
> => {
  return useMutation(getCreateJobMutationOptions(options));
};

/**
 * Returns a short-lived presigned PUT URL the browser can use to upload a large audio file directly to Google Cloud Storage, bypassing the Replit reverse-proxy request-body size limit. After the PUT succeeds, pass the returned objectKey to POST /jobs to create the abbreviation job.

 * @summary Request a presigned GCS URL for direct browser audio upload
 */
export const getRequestJobUploadUrlUrl = () => {
  return `/api/jobs/upload-url`;
};

export const requestJobUploadUrl = async (
  requestJobUploadUrlBody: RequestJobUploadUrlBody,
  options?: RequestInit,
): Promise<JobUploadUrlResponse> => {
  return customFetch<JobUploadUrlResponse>(getRequestJobUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(requestJobUploadUrlBody),
  });
};

export const getRequestJobUploadUrlMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestJobUploadUrl>>,
    TError,
    { data: BodyType<RequestJobUploadUrlBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestJobUploadUrl>>,
  TError,
  { data: BodyType<RequestJobUploadUrlBody> },
  TContext
> => {
  const mutationKey = ["requestJobUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestJobUploadUrl>>,
    { data: BodyType<RequestJobUploadUrlBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestJobUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestJobUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestJobUploadUrl>>
>;
export type RequestJobUploadUrlMutationBody = BodyType<RequestJobUploadUrlBody>;
export type RequestJobUploadUrlMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Request a presigned GCS URL for direct browser audio upload
 */
export const useRequestJobUploadUrl = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestJobUploadUrl>>,
    TError,
    { data: BodyType<RequestJobUploadUrlBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestJobUploadUrl>>,
  TError,
  { data: BodyType<RequestJobUploadUrlBody> },
  TContext
> => {
  return useMutation(getRequestJobUploadUrlMutationOptions(options));
};

/**
 * @summary Get aggregated stats for all jobs
 */
export const getGetJobStatsUrl = (params?: GetJobStatsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/jobs/stats?${stringifiedParams}`
    : `/api/jobs/stats`;
};

export const getJobStats = async (
  params?: GetJobStatsParams,
  options?: RequestInit,
): Promise<JobStats> => {
  return customFetch<JobStats>(getGetJobStatsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetJobStatsQueryKey = (params?: GetJobStatsParams) => {
  return [`/api/jobs/stats`, ...(params ? [params] : [])] as const;
};

export const getGetJobStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobStats>>,
  TError = ErrorType<unknown>,
>(
  params?: GetJobStatsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobStats>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobStats>>> = ({
    signal,
  }) => getJobStats(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobStats>>
>;
export type GetJobStatsQueryError = ErrorType<unknown>;

/**
 * @summary Get aggregated stats for all jobs
 */

export function useGetJobStats<
  TData = Awaited<ReturnType<typeof getJobStats>>,
  TError = ErrorType<unknown>,
>(
  params?: GetJobStatsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobStats>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetJobStatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Fetch and parse a podcast RSS feed, returning a list of episodes
 */
export const getGetRssEpisodesUrl = (params: GetRssEpisodesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/rss/episodes?${stringifiedParams}`
    : `/api/rss/episodes`;
};

export const getRssEpisodes = async (
  params: GetRssEpisodesParams,
  options?: RequestInit,
): Promise<RssFeedResult> => {
  return customFetch<RssFeedResult>(getGetRssEpisodesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetRssEpisodesQueryKey = (params?: GetRssEpisodesParams) => {
  return [`/api/rss/episodes`, ...(params ? [params] : [])] as const;
};

export const getGetRssEpisodesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRssEpisodes>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetRssEpisodesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRssEpisodes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRssEpisodesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRssEpisodes>>> = ({
    signal,
  }) => getRssEpisodes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRssEpisodes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRssEpisodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRssEpisodes>>
>;
export type GetRssEpisodesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Fetch and parse a podcast RSS feed, returning a list of episodes
 */

export function useGetRssEpisodes<
  TData = Awaited<ReturnType<typeof getRssEpisodes>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetRssEpisodesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRssEpisodes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRssEpisodesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a job from an RSS episode (server downloads audio)
 */
export const getCreateRssJobUrl = () => {
  return `/api/jobs/rss`;
};

export const createRssJob = async (
  createRssJobBody: CreateRssJobBody,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getCreateRssJobUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createRssJobBody),
  });
};

export const getCreateRssJobMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRssJob>>,
    TError,
    { data: BodyType<CreateRssJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRssJob>>,
  TError,
  { data: BodyType<CreateRssJobBody> },
  TContext
> => {
  const mutationKey = ["createRssJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRssJob>>,
    { data: BodyType<CreateRssJobBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createRssJob(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRssJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRssJob>>
>;
export type CreateRssJobMutationBody = BodyType<CreateRssJobBody>;
export type CreateRssJobMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a job from an RSS episode (server downloads audio)
 */
export const useCreateRssJob = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRssJob>>,
    TError,
    { data: BodyType<CreateRssJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createRssJob>>,
  TError,
  { data: BodyType<CreateRssJobBody> },
  TContext
> => {
  return useMutation(getCreateRssJobMutationOptions(options));
};

/**
 * Returns per-stage duration averages computed from the last 50 completed jobs. Used by the status page for historically-grounded ETA estimates.
 * @summary Get moving-average processing times from recent completed jobs
 */
export const getGetJobTimingStatsUrl = () => {
  return `/api/jobs/timing-stats`;
};

export const getJobTimingStats = async (
  options?: RequestInit,
): Promise<JobTimingStats> => {
  return customFetch<JobTimingStats>(getGetJobTimingStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetJobTimingStatsQueryKey = () => {
  return [`/api/jobs/timing-stats`] as const;
};

export const getGetJobTimingStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobTimingStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getJobTimingStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobTimingStatsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJobTimingStats>>
  > = ({ signal }) => getJobTimingStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobTimingStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobTimingStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobTimingStats>>
>;
export type GetJobTimingStatsQueryError = ErrorType<unknown>;

/**
 * @summary Get moving-average processing times from recent completed jobs
 */

export function useGetJobTimingStats<
  TData = Awaited<ReturnType<typeof getJobTimingStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getJobTimingStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetJobTimingStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the current position of the job in the ffmpeg-slot queue plus an estimated wait time based on recent slot-hold durations. Intended to be polled by the status page while the job is in `queued` state so the user can see "X jobs ahead of you" and roughly how long they will wait. Once the job starts processing the response still resolves successfully — callers should stop polling when `status` is no longer `queued`.

 * @summary Get the live ffmpeg-slot queue position and estimated wait for a job
 */
export const getGetJobQueuePositionUrl = (id: number) => {
  return `/api/jobs/${id}/queue-position`;
};

export const getJobQueuePosition = async (
  id: number,
  options?: RequestInit,
): Promise<JobQueuePosition> => {
  return customFetch<JobQueuePosition>(getGetJobQueuePositionUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetJobQueuePositionQueryKey = (id: number) => {
  return [`/api/jobs/${id}/queue-position`] as const;
};

export const getGetJobQueuePositionQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobQueuePosition>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobQueuePosition>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobQueuePositionQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJobQueuePosition>>
  > = ({ signal }) => getJobQueuePosition(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobQueuePosition>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobQueuePositionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobQueuePosition>>
>;
export type GetJobQueuePositionQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the live ffmpeg-slot queue position and estimated wait for a job
 */

export function useGetJobQueuePosition<
  TData = Awaited<ReturnType<typeof getJobQueuePosition>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobQueuePosition>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetJobQueuePositionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a job by ID
 */
export const getGetJobUrl = (id: number) => {
  return `/api/jobs/${id}`;
};

export const getJob = async (
  id: number,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getGetJobUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetJobQueryKey = (id: number) => {
  return [`/api/jobs/${id}`] as const;
};

export const getGetJobQueryOptions = <
  TData = Awaited<ReturnType<typeof getJob>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJob>>> = ({
    signal,
  }) => getJob(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetJobQueryResult = NonNullable<Awaited<ReturnType<typeof getJob>>>;
export type GetJobQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a job by ID
 */

export function useGetJob<
  TData = Awaited<ReturnType<typeof getJob>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetJobQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Delete a job and its associated files
 */
export const getDeleteJobUrl = (id: number) => {
  return `/api/jobs/${id}`;
};

export const deleteJob = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteJobUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteJobMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJob>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteJob>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteJob>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteJob(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteJob>>
>;

export type DeleteJobMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a job and its associated files
 */
export const useDeleteJob = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJob>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteJob>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteJobMutationOptions(options));
};

/**
 * @summary Stream or download the abbreviated audio output (auth-required, expiry-enforced)
 */
export const getDownloadJobOutputUrl = (id: number) => {
  return `/api/jobs/${id}/download`;
};

export const downloadJobOutput = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getDownloadJobOutputUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getDownloadJobOutputQueryKey = (id: number) => {
  return [`/api/jobs/${id}/download`] as const;
};

export const getDownloadJobOutputQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadJobOutput>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadJobOutput>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadJobOutputQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadJobOutput>>
  > = ({ signal }) => downloadJobOutput(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadJobOutput>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadJobOutputQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadJobOutput>>
>;
export type DownloadJobOutputQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Stream or download the abbreviated audio output (auth-required, expiry-enforced)
 */

export function useDownloadJobOutput<
  TData = Awaited<ReturnType<typeof downloadJobOutput>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadJobOutput>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadJobOutputQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Calls Gemini 2.5 Flash to write a visual brief from the episode transcript, then calls Imagen 3 and stores the result. Accepts an optional vibe profile (default: cinematic) and video format to size the image correctly. Returns 402 for free users, 429 when the monthly cap (30) or per-job cap (2) is reached. Can be called a second time to regenerate with a different vibe profile.

 * @summary Generate an AI image for a completed job (Pro only, 30/month, 2/job)
 */
export const getGenerateJobImageUrl = (id: number) => {
  return `/api/jobs/${id}/generate-image`;
};

export const generateJobImage = async (
  id: number,
  generateJobImageBody?: GenerateJobImageBody,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getGenerateJobImageUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateJobImageBody),
  });
};

export const getGenerateJobImageMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateJobImage>>,
    TError,
    { id: number; data: BodyType<GenerateJobImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateJobImage>>,
  TError,
  { id: number; data: BodyType<GenerateJobImageBody> },
  TContext
> => {
  const mutationKey = ["generateJobImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateJobImage>>,
    { id: number; data: BodyType<GenerateJobImageBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generateJobImage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateJobImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateJobImage>>
>;
export type GenerateJobImageMutationBody = BodyType<GenerateJobImageBody>;
export type GenerateJobImageMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Generate an AI image for a completed job (Pro only, 30/month, 2/job)
 */
export const useGenerateJobImage = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateJobImage>>,
    TError,
    { id: number; data: BodyType<GenerateJobImageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateJobImage>>,
  TError,
  { id: number; data: BodyType<GenerateJobImageBody> },
  TContext
> => {
  return useMutation(getGenerateJobImageMutationOptions(options));
};

/**
 * @summary Stream the AI-generated image for a job (auth-required, ownership-checked)
 */
export const getGetGeneratedImageUrl = (id: number) => {
  return `/api/jobs/${id}/generated-image`;
};

export const getGeneratedImage = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetGeneratedImageUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGeneratedImageQueryKey = (id: number) => {
  return [`/api/jobs/${id}/generated-image`] as const;
};

export const getGetGeneratedImageQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeneratedImage>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeneratedImage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGeneratedImageQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeneratedImage>>
  > = ({ signal }) => getGeneratedImage(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeneratedImage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGeneratedImageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeneratedImage>>
>;
export type GetGeneratedImageQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Stream the AI-generated image for a job (auth-required, ownership-checked)
 */

export function useGetGeneratedImage<
  TData = Awaited<ReturnType<typeof getGeneratedImage>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeneratedImage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGeneratedImageQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Clears the stored cinematic beat images (cinematicImages, cinematicStyle, cinematicFormat) for the given job. Use this when the user wants to regenerate cinematic images from scratch, e.g. after changing a setting. The next cinematic render will re-run beat detection and image generation.

 * @summary Clear pre-generated cinematic images for a job
 */
export const getResetCinematicImagesUrl = (id: number) => {
  return `/api/jobs/${id}/cinematic-images/reset`;
};

export const resetCinematicImages = async (
  id: number,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getResetCinematicImagesUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getResetCinematicImagesMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetCinematicImages>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetCinematicImages>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["resetCinematicImages"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetCinematicImages>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return resetCinematicImages(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetCinematicImagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetCinematicImages>>
>;

export type ResetCinematicImagesMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Clear pre-generated cinematic images for a job
 */
export const useResetCinematicImages = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetCinematicImages>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetCinematicImages>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getResetCinematicImagesMutationOptions(options));
};

/**
 * Combines the abbreviated audio with a background image (podcast artwork or AI-generated) and burned-in subtitles to produce a short-form social video (portrait 1080×1920, landscape 1920×1080, or square 1080×1080). FFmpeg encodes H.264/AAC MP4 with libass subtitles. The rendered video is stored in object storage and accessible via GET /jobs/{id}/video/download.

 * @summary Render a social video clip for a completed job
 */
export const getRenderJobVideoUrl = (id: number) => {
  return `/api/jobs/${id}/video`;
};

export const renderJobVideo = async (
  id: number,
  renderJobVideoBody: RenderJobVideoBody,
  options?: RequestInit,
): Promise<RenderJobVideo202> => {
  return customFetch<RenderJobVideo202>(getRenderJobVideoUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(renderJobVideoBody),
  });
};

export const getRenderJobVideoMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renderJobVideo>>,
    TError,
    { id: number; data: BodyType<RenderJobVideoBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renderJobVideo>>,
  TError,
  { id: number; data: BodyType<RenderJobVideoBody> },
  TContext
> => {
  const mutationKey = ["renderJobVideo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renderJobVideo>>,
    { id: number; data: BodyType<RenderJobVideoBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return renderJobVideo(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenderJobVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof renderJobVideo>>
>;
export type RenderJobVideoMutationBody = BodyType<RenderJobVideoBody>;
export type RenderJobVideoMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Render a social video clip for a completed job
 */
export const useRenderJobVideo = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renderJobVideo>>,
    TError,
    { id: number; data: BodyType<RenderJobVideoBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof renderJobVideo>>,
  TError,
  { id: number; data: BodyType<RenderJobVideoBody> },
  TContext
> => {
  return useMutation(getRenderJobVideoMutationOptions(options));
};

/**
 * @summary Stream the rendered social video for a job (auth-required, ownership-checked)
 */
export const getDownloadJobVideoUrl = (id: number) => {
  return `/api/jobs/${id}/video/download`;
};

export const downloadJobVideo = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getDownloadJobVideoUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getDownloadJobVideoQueryKey = (id: number) => {
  return [`/api/jobs/${id}/video/download`] as const;
};

export const getDownloadJobVideoQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadJobVideo>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadJobVideo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadJobVideoQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadJobVideo>>
  > = ({ signal }) => downloadJobVideo(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadJobVideo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadJobVideoQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadJobVideo>>
>;
export type DownloadJobVideoQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Stream the rendered social video for a job (auth-required, ownership-checked)
 */

export function useDownloadJobVideo<
  TData = Awaited<ReturnType<typeof downloadJobVideo>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadJobVideo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadJobVideoQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Retry a failed job using the original uploaded file
 */
export const getRetryJobUrl = (id: number) => {
  return `/api/jobs/${id}/retry`;
};

export const retryJob = async (
  id: number,
  retryJobBody?: RetryJobBody,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getRetryJobUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(retryJobBody),
  });
};

export const getRetryJobMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryJob>>,
    TError,
    { id: number; data: BodyType<RetryJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryJob>>,
  TError,
  { id: number; data: BodyType<RetryJobBody> },
  TContext
> => {
  const mutationKey = ["retryJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryJob>>,
    { id: number; data: BodyType<RetryJobBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return retryJob(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryJob>>
>;
export type RetryJobMutationBody = BodyType<RetryJobBody>;
export type RetryJobMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Retry a failed job using the original uploaded file
 */
export const useRetryJob = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryJob>>,
    TError,
    { id: number; data: BodyType<RetryJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryJob>>,
  TError,
  { id: number; data: BodyType<RetryJobBody> },
  TContext
> => {
  return useMutation(getRetryJobMutationOptions(options));
};

/**
 * @summary Re-process a completed RSS job with optional new mode or target percentage
 */
export const getRegenerateJobUrl = (id: number) => {
  return `/api/jobs/${id}/regenerate`;
};

export const regenerateJob = async (
  id: number,
  regenerateJobBody?: RegenerateJobBody,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getRegenerateJobUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(regenerateJobBody),
  });
};

export const getRegenerateJobMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateJob>>,
    TError,
    { id: number; data: BodyType<RegenerateJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateJob>>,
  TError,
  { id: number; data: BodyType<RegenerateJobBody> },
  TContext
> => {
  const mutationKey = ["regenerateJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateJob>>,
    { id: number; data: BodyType<RegenerateJobBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateJob(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateJob>>
>;
export type RegenerateJobMutationBody = BodyType<RegenerateJobBody>;
export type RegenerateJobMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Re-process a completed RSS job with optional new mode or target percentage
 */
export const useRegenerateJob = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateJob>>,
    TError,
    { id: number; data: BodyType<RegenerateJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateJob>>,
  TError,
  { id: number; data: BodyType<RegenerateJobBody> },
  TContext
> => {
  return useMutation(getRegenerateJobMutationOptions(options));
};

/**
 * Trims the condensed output audio to the quote's clip boundaries, overlays the episode artwork (or AI-generated image) with burned-in subtitles, and encodes an MP4. The render runs in the background; poll GET /api/jobs/:id/quotes/:index/video until videoStatus is null (success) or "failed".

 * @summary Render a short video clip for a single key quote
 */
export const getRenderQuoteVideoUrl = (id: number, index: number) => {
  return `/api/jobs/${id}/quotes/${index}/video`;
};

export const renderQuoteVideo = async (
  id: number,
  index: number,
  renderQuoteVideoBody?: RenderQuoteVideoBody,
  options?: RequestInit,
): Promise<QuoteVideo> => {
  return customFetch<QuoteVideo>(getRenderQuoteVideoUrl(id, index), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(renderQuoteVideoBody),
  });
};

export const getRenderQuoteVideoMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renderQuoteVideo>>,
    TError,
    { id: number; index: number; data: BodyType<RenderQuoteVideoBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renderQuoteVideo>>,
  TError,
  { id: number; index: number; data: BodyType<RenderQuoteVideoBody> },
  TContext
> => {
  const mutationKey = ["renderQuoteVideo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renderQuoteVideo>>,
    { id: number; index: number; data: BodyType<RenderQuoteVideoBody> }
  > = (props) => {
    const { id, index, data } = props ?? {};

    return renderQuoteVideo(id, index, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenderQuoteVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof renderQuoteVideo>>
>;
export type RenderQuoteVideoMutationBody = BodyType<RenderQuoteVideoBody>;
export type RenderQuoteVideoMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Render a short video clip for a single key quote
 */
export const useRenderQuoteVideo = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renderQuoteVideo>>,
    TError,
    { id: number; index: number; data: BodyType<RenderQuoteVideoBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof renderQuoteVideo>>,
  TError,
  { id: number; index: number; data: BodyType<RenderQuoteVideoBody> },
  TContext
> => {
  return useMutation(getRenderQuoteVideoMutationOptions(options));
};

/**
 * @summary Get the render status for a per-quote video
 */
export const getGetQuoteVideoStatusUrl = (id: number, index: number) => {
  return `/api/jobs/${id}/quotes/${index}/video/status`;
};

export const getQuoteVideoStatus = async (
  id: number,
  index: number,
  options?: RequestInit,
): Promise<QuoteVideo> => {
  return customFetch<QuoteVideo>(getGetQuoteVideoStatusUrl(id, index), {
    ...options,
    method: "GET",
  });
};

export const getGetQuoteVideoStatusQueryKey = (id: number, index: number) => {
  return [`/api/jobs/${id}/quotes/${index}/video/status`] as const;
};

export const getGetQuoteVideoStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuoteVideoStatus>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  index: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuoteVideoStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuoteVideoStatusQueryKey(id, index);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuoteVideoStatus>>
  > = ({ signal }) =>
    getQuoteVideoStatus(id, index, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && index),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuoteVideoStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQuoteVideoStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuoteVideoStatus>>
>;
export type GetQuoteVideoStatusQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the render status for a per-quote video
 */

export function useGetQuoteVideoStatus<
  TData = Awaited<ReturnType<typeof getQuoteVideoStatus>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  index: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuoteVideoStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuoteVideoStatusQueryOptions(id, index, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Stream the rendered per-quote video (auth-required, ownership-checked)
 */
export const getDownloadQuoteVideoUrl = (id: number, index: number) => {
  return `/api/jobs/${id}/quotes/${index}/video/download`;
};

export const downloadQuoteVideo = async (
  id: number,
  index: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getDownloadQuoteVideoUrl(id, index), {
    ...options,
    method: "GET",
  });
};

export const getDownloadQuoteVideoQueryKey = (id: number, index: number) => {
  return [`/api/jobs/${id}/quotes/${index}/video/download`] as const;
};

export const getDownloadQuoteVideoQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadQuoteVideo>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  index: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadQuoteVideo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadQuoteVideoQueryKey(id, index);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadQuoteVideo>>
  > = ({ signal }) =>
    downloadQuoteVideo(id, index, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && index),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadQuoteVideo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadQuoteVideoQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadQuoteVideo>>
>;
export type DownloadQuoteVideoQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Stream the rendered per-quote video (auth-required, ownership-checked)
 */

export function useDownloadQuoteVideo<
  TData = Awaited<ReturnType<typeof downloadQuoteVideo>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  index: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadQuoteVideo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadQuoteVideoQueryOptions(id, index, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a 30-minute signed GCS URL for the rendered quote video. The browser can download directly from GCS without proxying through the API server, which avoids response-size limits. Only available once videoStatus is null and videoUrl is set.

 * @summary Get a short-lived signed URL to download the rendered per-quote video
 */
export const getGetQuoteVideoUrlUrl = (id: number, index: number) => {
  return `/api/jobs/${id}/quotes/${index}/video-url`;
};

export const getQuoteVideoUrl = async (
  id: number,
  index: number,
  options?: RequestInit,
): Promise<GetQuoteVideoUrl200> => {
  return customFetch<GetQuoteVideoUrl200>(getGetQuoteVideoUrlUrl(id, index), {
    ...options,
    method: "GET",
  });
};

export const getGetQuoteVideoUrlQueryKey = (id: number, index: number) => {
  return [`/api/jobs/${id}/quotes/${index}/video-url`] as const;
};

export const getGetQuoteVideoUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuoteVideoUrl>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  index: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuoteVideoUrl>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuoteVideoUrlQueryKey(id, index);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuoteVideoUrl>>
  > = ({ signal }) =>
    getQuoteVideoUrl(id, index, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && index),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuoteVideoUrl>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQuoteVideoUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuoteVideoUrl>>
>;
export type GetQuoteVideoUrlQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a short-lived signed URL to download the rendered per-quote video
 */

export function useGetQuoteVideoUrl<
  TData = Awaited<ReturnType<typeof getQuoteVideoUrl>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  index: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuoteVideoUrl>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuoteVideoUrlQueryOptions(id, index, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all per-quote video records for a job
 */
export const getListQuoteVideosUrl = (id: number) => {
  return `/api/jobs/${id}/quotes/videos`;
};

export const listQuoteVideos = async (
  id: number,
  options?: RequestInit,
): Promise<ListQuoteVideos200> => {
  return customFetch<ListQuoteVideos200>(getListQuoteVideosUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListQuoteVideosQueryKey = (id: number) => {
  return [`/api/jobs/${id}/quotes/videos`] as const;
};

export const getListQuoteVideosQueryOptions = <
  TData = Awaited<ReturnType<typeof listQuoteVideos>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listQuoteVideos>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListQuoteVideosQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listQuoteVideos>>> = ({
    signal,
  }) => listQuoteVideos(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listQuoteVideos>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListQuoteVideosQueryResult = NonNullable<
  Awaited<ReturnType<typeof listQuoteVideos>>
>;
export type ListQuoteVideosQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all per-quote video records for a job
 */

export function useListQuoteVideos<
  TData = Awaited<ReturnType<typeof listQuoteVideos>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listQuoteVideos>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListQuoteVideosQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Toggle global auto-quote-video preference for the current user
 */
export const getUpdateQuoteVideoPreferenceUrl = () => {
  return `/api/auth/preferences/quote-videos`;
};

export const updateQuoteVideoPreference = async (
  updateQuoteVideoPreferenceBody: UpdateQuoteVideoPreferenceBody,
  options?: RequestInit,
): Promise<UpdateQuoteVideoPreference200> => {
  return customFetch<UpdateQuoteVideoPreference200>(
    getUpdateQuoteVideoPreferenceUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(updateQuoteVideoPreferenceBody),
    },
  );
};

export const getUpdateQuoteVideoPreferenceMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateQuoteVideoPreference>>,
    TError,
    { data: BodyType<UpdateQuoteVideoPreferenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateQuoteVideoPreference>>,
  TError,
  { data: BodyType<UpdateQuoteVideoPreferenceBody> },
  TContext
> => {
  const mutationKey = ["updateQuoteVideoPreference"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateQuoteVideoPreference>>,
    { data: BodyType<UpdateQuoteVideoPreferenceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateQuoteVideoPreference(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateQuoteVideoPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateQuoteVideoPreference>>
>;
export type UpdateQuoteVideoPreferenceMutationBody =
  BodyType<UpdateQuoteVideoPreferenceBody>;
export type UpdateQuoteVideoPreferenceMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Toggle global auto-quote-video preference for the current user
 */
export const useUpdateQuoteVideoPreference = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateQuoteVideoPreference>>,
    TError,
    { data: BodyType<UpdateQuoteVideoPreferenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateQuoteVideoPreference>>,
  TError,
  { data: BodyType<UpdateQuoteVideoPreferenceBody> },
  TContext
> => {
  return useMutation(getUpdateQuoteVideoPreferenceMutationOptions(options));
};

/**
 * @summary Manually override per-word cuts for a completed narrative job and re-stitch the output
 */
export const getUpdateWordCutsUrl = (id: number) => {
  return `/api/jobs/${id}/word-cuts`;
};

export const updateWordCuts = async (
  id: number,
  updateWordCutsBody: UpdateWordCutsBody,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getUpdateWordCutsUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateWordCutsBody),
  });
};

export const getUpdateWordCutsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWordCuts>>,
    TError,
    { id: number; data: BodyType<UpdateWordCutsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWordCuts>>,
  TError,
  { id: number; data: BodyType<UpdateWordCutsBody> },
  TContext
> => {
  const mutationKey = ["updateWordCuts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWordCuts>>,
    { id: number; data: BodyType<UpdateWordCutsBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateWordCuts(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWordCutsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWordCuts>>
>;
export type UpdateWordCutsMutationBody = BodyType<UpdateWordCutsBody>;
export type UpdateWordCutsMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Manually override per-word cuts for a completed narrative job and re-stitch the output
 */
export const useUpdateWordCuts = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWordCuts>>,
    TError,
    { id: number; data: BodyType<UpdateWordCutsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWordCuts>>,
  TError,
  { id: number; data: BodyType<UpdateWordCutsBody> },
  TContext
> => {
  return useMutation(getUpdateWordCutsMutationOptions(options));
};

/**
 * @summary List all RSS feed subscriptions for the authenticated user
 */
export const getListSubscriptionsUrl = () => {
  return `/api/rss/subscriptions`;
};

export const listSubscriptions = async (
  options?: RequestInit,
): Promise<ListSubscriptions200> => {
  return customFetch<ListSubscriptions200>(getListSubscriptionsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSubscriptionsQueryKey = () => {
  return [`/api/rss/subscriptions`] as const;
};

export const getListSubscriptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSubscriptions>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSubscriptions>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSubscriptionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSubscriptions>>
  > = ({ signal }) => listSubscriptions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSubscriptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSubscriptions>>
>;
export type ListSubscriptionsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all RSS feed subscriptions for the authenticated user
 */

export function useListSubscriptions<
  TData = Awaited<ReturnType<typeof listSubscriptions>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSubscriptions>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSubscriptionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Subscribe to an RSS feed for auto-processing of new episodes
 */
export const getCreateSubscriptionUrl = () => {
  return `/api/rss/subscriptions`;
};

export const createSubscription = async (
  createSubscriptionBody: CreateSubscriptionBody,
  options?: RequestInit,
): Promise<CreateSubscription201> => {
  return customFetch<CreateSubscription201>(getCreateSubscriptionUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSubscriptionBody),
  });
};

export const getCreateSubscriptionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSubscription>>,
    TError,
    { data: BodyType<CreateSubscriptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSubscription>>,
  TError,
  { data: BodyType<CreateSubscriptionBody> },
  TContext
> => {
  const mutationKey = ["createSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSubscription>>,
    { data: BodyType<CreateSubscriptionBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSubscription(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSubscription>>
>;
export type CreateSubscriptionMutationBody = BodyType<CreateSubscriptionBody>;
export type CreateSubscriptionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Subscribe to an RSS feed for auto-processing of new episodes
 */
export const useCreateSubscription = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSubscription>>,
    TError,
    { data: BodyType<CreateSubscriptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSubscription>>,
  TError,
  { data: BodyType<CreateSubscriptionBody> },
  TContext
> => {
  return useMutation(getCreateSubscriptionMutationOptions(options));
};

/**
 * @summary Pause or resume an RSS feed subscription
 */
export const getUpdateSubscriptionUrl = (id: number) => {
  return `/api/rss/subscriptions/${id}`;
};

export const updateSubscription = async (
  id: number,
  updateSubscriptionBody: UpdateSubscriptionBody,
  options?: RequestInit,
): Promise<UpdateSubscription200> => {
  return customFetch<UpdateSubscription200>(getUpdateSubscriptionUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSubscriptionBody),
  });
};

export const getUpdateSubscriptionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubscription>>,
    TError,
    { id: number; data: BodyType<UpdateSubscriptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSubscription>>,
  TError,
  { id: number; data: BodyType<UpdateSubscriptionBody> },
  TContext
> => {
  const mutationKey = ["updateSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSubscription>>,
    { id: number; data: BodyType<UpdateSubscriptionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSubscription(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSubscription>>
>;
export type UpdateSubscriptionMutationBody = BodyType<UpdateSubscriptionBody>;
export type UpdateSubscriptionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Pause or resume an RSS feed subscription
 */
export const useUpdateSubscription = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubscription>>,
    TError,
    { id: number; data: BodyType<UpdateSubscriptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSubscription>>,
  TError,
  { id: number; data: BodyType<UpdateSubscriptionBody> },
  TContext
> => {
  return useMutation(getUpdateSubscriptionMutationOptions(options));
};

/**
 * @summary Delete an RSS feed subscription
 */
export const getDeleteSubscriptionUrl = (id: number) => {
  return `/api/rss/subscriptions/${id}`;
};

export const deleteSubscription = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSubscriptionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSubscriptionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSubscription>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSubscription>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSubscription>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSubscription(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSubscription>>
>;

export type DeleteSubscriptionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete an RSS feed subscription
 */
export const useDeleteSubscription = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSubscription>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSubscription>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteSubscriptionMutationOptions(options));
};

/**
 * Returns the most recent episodes from the feed with their processed status for the authenticated user.
 * @summary List recent episodes from a subscription's feed
 */
export const getListSubscriptionEpisodesUrl = (
  id: number,
  params?: ListSubscriptionEpisodesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/rss/subscriptions/${id}/episodes?${stringifiedParams}`
    : `/api/rss/subscriptions/${id}/episodes`;
};

export const listSubscriptionEpisodes = async (
  id: number,
  params?: ListSubscriptionEpisodesParams,
  options?: RequestInit,
): Promise<ListSubscriptionEpisodes200> => {
  return customFetch<ListSubscriptionEpisodes200>(
    getListSubscriptionEpisodesUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListSubscriptionEpisodesQueryKey = (
  id: number,
  params?: ListSubscriptionEpisodesParams,
) => {
  return [
    `/api/rss/subscriptions/${id}/episodes`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListSubscriptionEpisodesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSubscriptionEpisodes>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  params?: ListSubscriptionEpisodesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSubscriptionEpisodes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSubscriptionEpisodesQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSubscriptionEpisodes>>
  > = ({ signal }) =>
    listSubscriptionEpisodes(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listSubscriptionEpisodes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSubscriptionEpisodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSubscriptionEpisodes>>
>;
export type ListSubscriptionEpisodesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List recent episodes from a subscription's feed
 */

export function useListSubscriptionEpisodes<
  TData = Awaited<ReturnType<typeof listSubscriptionEpisodes>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  params?: ListSubscriptionEpisodesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSubscriptionEpisodes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSubscriptionEpisodesQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Accepts an array of specific episode audio URLs to queue.
 * @summary Queue catch-up episodes for a subscription
 */
export const getBackfillSubscriptionUrl = (id: number) => {
  return `/api/rss/subscriptions/${id}/backfill`;
};

export const backfillSubscription = async (
  id: number,
  backfillSubscriptionBody: BackfillSubscriptionBody,
  options?: RequestInit,
): Promise<BackfillSubscription200> => {
  return customFetch<BackfillSubscription200>(getBackfillSubscriptionUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(backfillSubscriptionBody),
  });
};

export const getBackfillSubscriptionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backfillSubscription>>,
    TError,
    { id: number; data: BodyType<BackfillSubscriptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backfillSubscription>>,
  TError,
  { id: number; data: BodyType<BackfillSubscriptionBody> },
  TContext
> => {
  const mutationKey = ["backfillSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backfillSubscription>>,
    { id: number; data: BodyType<BackfillSubscriptionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return backfillSubscription(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackfillSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof backfillSubscription>>
>;
export type BackfillSubscriptionMutationBody =
  BodyType<BackfillSubscriptionBody>;
export type BackfillSubscriptionMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Queue catch-up episodes for a subscription
 */
export const useBackfillSubscription = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backfillSubscription>>,
    TError,
    { id: number; data: BodyType<BackfillSubscriptionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof backfillSubscription>>,
  TError,
  { id: number; data: BodyType<BackfillSubscriptionBody> },
  TContext
> => {
  return useMutation(getBackfillSubscriptionMutationOptions(options));
};

/**
 * @summary List connected social platform accounts for the current user
 */
export const getListSocialAccountsUrl = () => {
  return `/api/social/accounts`;
};

export const listSocialAccounts = async (
  options?: RequestInit,
): Promise<ListSocialAccounts200> => {
  return customFetch<ListSocialAccounts200>(getListSocialAccountsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSocialAccountsQueryKey = () => {
  return [`/api/social/accounts`] as const;
};

export const getListSocialAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSocialAccounts>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSocialAccounts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSocialAccountsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSocialAccounts>>
  > = ({ signal }) => listSocialAccounts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSocialAccounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSocialAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSocialAccounts>>
>;
export type ListSocialAccountsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List connected social platform accounts for the current user
 */

export function useListSocialAccounts<
  TData = Awaited<ReturnType<typeof listSocialAccounts>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSocialAccounts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSocialAccountsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List social posts for the current user with optional filters
 */
export const getListSocialPostsUrl = (params?: ListSocialPostsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/social/posts?${stringifiedParams}`
    : `/api/social/posts`;
};

export const listSocialPosts = async (
  params?: ListSocialPostsParams,
  options?: RequestInit,
): Promise<ListSocialPosts200> => {
  return customFetch<ListSocialPosts200>(getListSocialPostsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSocialPostsQueryKey = (params?: ListSocialPostsParams) => {
  return [`/api/social/posts`, ...(params ? [params] : [])] as const;
};

export const getListSocialPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSocialPosts>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListSocialPostsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSocialPosts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSocialPostsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSocialPosts>>> = ({
    signal,
  }) => listSocialPosts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSocialPosts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSocialPostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSocialPosts>>
>;
export type ListSocialPostsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List social posts for the current user with optional filters
 */

export function useListSocialPosts<
  TData = Awaited<ReturnType<typeof listSocialPosts>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListSocialPostsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSocialPosts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSocialPostsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get the social post associated with a specific job
 */
export const getGetSocialPostByJobUrl = (jobId: number) => {
  return `/api/social/posts/by-job/${jobId}`;
};

export const getSocialPostByJob = async (
  jobId: number,
  options?: RequestInit,
): Promise<GetSocialPostByJob200> => {
  return customFetch<GetSocialPostByJob200>(getGetSocialPostByJobUrl(jobId), {
    ...options,
    method: "GET",
  });
};

export const getGetSocialPostByJobQueryKey = (jobId: number) => {
  return [`/api/social/posts/by-job/${jobId}`] as const;
};

export const getGetSocialPostByJobQueryOptions = <
  TData = Awaited<ReturnType<typeof getSocialPostByJob>>,
  TError = ErrorType<ErrorResponse>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSocialPostByJob>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSocialPostByJobQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSocialPostByJob>>
  > = ({ signal }) => getSocialPostByJob(jobId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSocialPostByJob>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSocialPostByJobQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSocialPostByJob>>
>;
export type GetSocialPostByJobQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the social post associated with a specific job
 */

export function useGetSocialPostByJob<
  TData = Awaited<ReturnType<typeof getSocialPostByJob>>,
  TError = ErrorType<ErrorResponse>,
>(
  jobId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSocialPostByJob>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSocialPostByJobQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Edit the title and/or description of a pending social post
 */
export const getUpdateSocialPostUrl = (id: number) => {
  return `/api/social/posts/${id}`;
};

export const updateSocialPost = async (
  id: number,
  updateSocialPostBody: UpdateSocialPostBody,
  options?: RequestInit,
): Promise<UpdateSocialPost200> => {
  return customFetch<UpdateSocialPost200>(getUpdateSocialPostUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSocialPostBody),
  });
};

export const getUpdateSocialPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSocialPost>>,
    TError,
    { id: number; data: BodyType<UpdateSocialPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSocialPost>>,
  TError,
  { id: number; data: BodyType<UpdateSocialPostBody> },
  TContext
> => {
  const mutationKey = ["updateSocialPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSocialPost>>,
    { id: number; data: BodyType<UpdateSocialPostBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSocialPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSocialPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSocialPost>>
>;
export type UpdateSocialPostMutationBody = BodyType<UpdateSocialPostBody>;
export type UpdateSocialPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Edit the title and/or description of a pending social post
 */
export const useUpdateSocialPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSocialPost>>,
    TError,
    { id: number; data: BodyType<UpdateSocialPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSocialPost>>,
  TError,
  { id: number; data: BodyType<UpdateSocialPostBody> },
  TContext
> => {
  return useMutation(getUpdateSocialPostMutationOptions(options));
};

/**
 * @summary Discard a pending social post
 */
export const getDiscardSocialPostUrl = (id: number) => {
  return `/api/social/posts/${id}`;
};

export const discardSocialPost = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDiscardSocialPostUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDiscardSocialPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof discardSocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof discardSocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["discardSocialPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof discardSocialPost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return discardSocialPost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DiscardSocialPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof discardSocialPost>>
>;

export type DiscardSocialPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Discard a pending social post
 */
export const useDiscardSocialPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof discardSocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof discardSocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDiscardSocialPostMutationOptions(options));
};

/**
 * @summary Approve a pending social post for publishing
 */
export const getApproveSocialPostUrl = (id: number) => {
  return `/api/social/posts/${id}/approve`;
};

export const approveSocialPost = async (
  id: number,
  options?: RequestInit,
): Promise<ApproveSocialPost200> => {
  return customFetch<ApproveSocialPost200>(getApproveSocialPostUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getApproveSocialPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveSocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveSocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["approveSocialPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveSocialPost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return approveSocialPost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveSocialPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveSocialPost>>
>;

export type ApproveSocialPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Approve a pending social post for publishing
 */
export const useApproveSocialPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveSocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveSocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getApproveSocialPostMutationOptions(options));
};

/**
 * @summary Stream the landscape thumbnail image for a social post
 */
export const getGetSocialPostThumbnailUrl = (id: number) => {
  return `/api/social/posts/${id}/thumbnail`;
};

export const getSocialPostThumbnail = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetSocialPostThumbnailUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetSocialPostThumbnailQueryKey = (id: number) => {
  return [`/api/social/posts/${id}/thumbnail`] as const;
};

export const getGetSocialPostThumbnailQueryOptions = <
  TData = Awaited<ReturnType<typeof getSocialPostThumbnail>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSocialPostThumbnail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSocialPostThumbnailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSocialPostThumbnail>>
  > = ({ signal }) => getSocialPostThumbnail(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSocialPostThumbnail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSocialPostThumbnailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSocialPostThumbnail>>
>;
export type GetSocialPostThumbnailQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Stream the landscape thumbnail image for a social post
 */

export function useGetSocialPostThumbnail<
  TData = Awaited<ReturnType<typeof getSocialPostThumbnail>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSocialPostThumbnail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSocialPostThumbnailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Stream the landscape video for a social post
 */
export const getGetSocialPostVideoUrl = (id: number) => {
  return `/api/social/posts/${id}/video`;
};

export const getSocialPostVideo = async (
  id: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetSocialPostVideoUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetSocialPostVideoQueryKey = (id: number) => {
  return [`/api/social/posts/${id}/video`] as const;
};

export const getGetSocialPostVideoQueryOptions = <
  TData = Awaited<ReturnType<typeof getSocialPostVideo>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSocialPostVideo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSocialPostVideoQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSocialPostVideo>>
  > = ({ signal }) => getSocialPostVideo(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSocialPostVideo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSocialPostVideoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSocialPostVideo>>
>;
export type GetSocialPostVideoQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Stream the landscape video for a social post
 */

export function useGetSocialPostVideo<
  TData = Awaited<ReturnType<typeof getSocialPostVideo>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSocialPostVideo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSocialPostVideoQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Retry dispatching a failed social post
 */
export const getRetrySocialPostUrl = (id: number) => {
  return `/api/social/posts/${id}/retry`;
};

export const retrySocialPost = async (
  id: number,
  options?: RequestInit,
): Promise<RetrySocialPost200> => {
  return customFetch<RetrySocialPost200>(getRetrySocialPostUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRetrySocialPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retrySocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retrySocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["retrySocialPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retrySocialPost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return retrySocialPost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetrySocialPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof retrySocialPost>>
>;

export type RetrySocialPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Retry dispatching a failed social post
 */
export const useRetrySocialPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retrySocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retrySocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRetrySocialPostMutationOptions(options));
};

/**
 * @summary Revert a discarded social post back to pending approval
 */
export const getReopenSocialPostUrl = (id: number) => {
  return `/api/social/posts/${id}/reopen`;
};

export const reopenSocialPost = async (
  id: number,
  options?: RequestInit,
): Promise<ReopenSocialPost200> => {
  return customFetch<ReopenSocialPost200>(getReopenSocialPostUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getReopenSocialPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reopenSocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reopenSocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["reopenSocialPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reopenSocialPost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return reopenSocialPost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReopenSocialPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof reopenSocialPost>>
>;

export type ReopenSocialPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Revert a discarded social post back to pending approval
 */
export const useReopenSocialPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reopenSocialPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reopenSocialPost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getReopenSocialPostMutationOptions(options));
};

/**
 * @summary Disconnect and remove a connected social account
 */
export const getDisconnectSocialAccountUrl = (id: number) => {
  return `/api/social/accounts/${id}`;
};

export const disconnectSocialAccount = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDisconnectSocialAccountUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDisconnectSocialAccountMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectSocialAccount>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectSocialAccount>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["disconnectSocialAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectSocialAccount>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return disconnectSocialAccount(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectSocialAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectSocialAccount>>
>;

export type DisconnectSocialAccountMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Disconnect and remove a connected social account
 */
export const useDisconnectSocialAccount = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectSocialAccount>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectSocialAccount>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDisconnectSocialAccountMutationOptions(options));
};

/**
 * **Browser-redirect only.** This endpoint issues a 302 redirect to the Google OAuth consent screen. It must be invoked via browser navigation (e.g. `window.location.href = getSocialOAuthUrl('youtube')`), NOT via fetch/XMLHttpRequest or React Query — doing so will follow the redirect inside the fetch context and fail due to CORS restrictions. Use the `getSocialOAuthUrl` helper from `@workspace/api-client-react` to construct the correct URL for navigation.

 * @summary Begin YouTube OAuth connection flow (redirects to Google)
 */
export const getStartYouTubeOAuthUrl = () => {
  return `/api/social/oauth/youtube/start`;
};

export const startYouTubeOAuth = async (
  options?: RequestInit,
): Promise<unknown> => {
  return customFetch<unknown>(getStartYouTubeOAuthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getStartYouTubeOAuthQueryKey = () => {
  return [`/api/social/oauth/youtube/start`] as const;
};

export const getStartYouTubeOAuthQueryOptions = <
  TData = Awaited<ReturnType<typeof startYouTubeOAuth>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof startYouTubeOAuth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStartYouTubeOAuthQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof startYouTubeOAuth>>
  > = ({ signal }) => startYouTubeOAuth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof startYouTubeOAuth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type StartYouTubeOAuthQueryResult = NonNullable<
  Awaited<ReturnType<typeof startYouTubeOAuth>>
>;
export type StartYouTubeOAuthQueryError = ErrorType<void>;

/**
 * @summary Begin YouTube OAuth connection flow (redirects to Google)
 */

export function useStartYouTubeOAuth<
  TData = Awaited<ReturnType<typeof startYouTubeOAuth>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof startYouTubeOAuth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getStartYouTubeOAuthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * **Browser-redirect only.** This endpoint issues a 302 redirect to the LinkedIn OAuth consent screen. It must be invoked via browser navigation (e.g. `window.location.href = getSocialOAuthUrl('linkedin')`), NOT via fetch/XMLHttpRequest or React Query — doing so will follow the redirect inside the fetch context and fail due to CORS restrictions. Use the `getSocialOAuthUrl` helper from `@workspace/api-client-react` to construct the correct URL for navigation.

 * @summary Begin LinkedIn OAuth connection flow (redirects to LinkedIn)
 */
export const getStartLinkedInOAuthUrl = () => {
  return `/api/social/oauth/linkedin/start`;
};

export const startLinkedInOAuth = async (
  options?: RequestInit,
): Promise<unknown> => {
  return customFetch<unknown>(getStartLinkedInOAuthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getStartLinkedInOAuthQueryKey = () => {
  return [`/api/social/oauth/linkedin/start`] as const;
};

export const getStartLinkedInOAuthQueryOptions = <
  TData = Awaited<ReturnType<typeof startLinkedInOAuth>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof startLinkedInOAuth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStartLinkedInOAuthQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof startLinkedInOAuth>>
  > = ({ signal }) => startLinkedInOAuth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof startLinkedInOAuth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type StartLinkedInOAuthQueryResult = NonNullable<
  Awaited<ReturnType<typeof startLinkedInOAuth>>
>;
export type StartLinkedInOAuthQueryError = ErrorType<void>;

/**
 * @summary Begin LinkedIn OAuth connection flow (redirects to LinkedIn)
 */

export function useStartLinkedInOAuth<
  TData = Awaited<ReturnType<typeof startLinkedInOAuth>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof startLinkedInOAuth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getStartLinkedInOAuthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
